import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserQueryKeys } from '@enums/react-query-keys';
import { User } from '@interfaces/models/user';
import UserService from '@services/user-service';

type UpdatePersonalInformationPayload = {
  firstName: string;
  lastName: string;
  username: string;
  mood?: string;
};

const useUpdatePersonalInformation = (userId: User['id']) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdatePersonalInformationPayload) => UserService.updatePersonalInformation(userId, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [UserQueryKeys.USER] }),
  });
};

export default useUpdatePersonalInformation;
